import type { Register } from 'react-router';

/**
 * Union of every route id this app registers via React Router's typegen
 * (regenerated into `.react-router/types` by the `precompile-routes` step).
 * Falls back to `never` if typegen has not run.
 */
export type RouteId = Register extends { routeModules: infer Modules }
  ? keyof Modules
  : never;

export const accountPages = ['routes/_menu.account'] satisfies RouteId[];

export const orderReviewPages = [
  'routes/_menu.account.reservations._index',
] satisfies RouteId[];

export const customRowPages = [
  'routes/_menu.($storeSlug).rows.$customRowId.$slug',
  'routes/_menu.store.$storeId.rows.$customRowId.$slug',
] satisfies RouteId[];

export const featuredPages = [
  'routes/_menu.($storeSlug).featured._index',
  'routes/_menu.store.$storeId.featured._index',
] satisfies RouteId[];

export const categoryPages = [
  'routes/_menu.($storeSlug).edible._index',
  'routes/_menu.($storeSlug).extract._index',
  'routes/_menu.($storeSlug).flower._index',
  'routes/_menu.($storeSlug).gear._index',
  'routes/_menu.($storeSlug).grow._index',
  'routes/_menu.($storeSlug).merch._index',
  'routes/_menu.($storeSlug).pre-roll._index',
  'routes/_menu.($storeSlug).tincture._index',
  'routes/_menu.($storeSlug).topical._index',
  'routes/_menu.($storeSlug).vape._index',
  'routes/_menu.($storeSlug).shop-all._index',

  'routes/_menu.store.$storeId.edible._index',
  'routes/_menu.store.$storeId.extract._index',
  'routes/_menu.store.$storeId.flower._index',
  'routes/_menu.store.$storeId.gear._index',
  'routes/_menu.store.$storeId.grow._index',
  'routes/_menu.store.$storeId.merch._index',
  'routes/_menu.store.$storeId.pre-roll._index',
  'routes/_menu.store.$storeId.tincture._index',
  'routes/_menu.store.$storeId.topical._index',
  'routes/_menu.store.$storeId.vape._index',
  'routes/_menu.store.$storeId.shop-all._index',
] satisfies RouteId[];

export const plpPages = [
  ...featuredPages,
  ...categoryPages,
  ...customRowPages,

  'routes/_menu.search',

  'routes/_menu.($storeSlug).deals._index',
  'routes/_menu.($storeSlug).deals.$dealId.$slug',
  'routes/_menu.($storeSlug).jane-gold._index',
  'routes/_menu.($storeSlug).jane-gold.$specialId.$slug',

  'routes/_menu.store.$storeId.deals._index',
  'routes/_menu.store.$storeId.deals.$dealId.$slug',
  'routes/_menu.store.$storeId.jane-gold._index',
  'routes/_menu.store.$storeId.jane-gold.$specialId.$slug',
] satisfies RouteId[];

export const pdpPages = [
  'routes/_menu.products.$productId.$slug',
] satisfies RouteId[];

export const isRouteInGroup = <Id extends RouteId>(
  group: readonly Id[],
  id: string
): id is Id => group.some((routeId) => routeId === id);
